import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import StickyBox from 'react-sticky-box';
import { userDepartmentTypes, userAccountTypes, departmentsTypes } from '../../types/user';

import { generateReport, setStatus } from '../../downloads/actions';
import { options } from '../../downloads/reducer';
import { requestSubmittedReturnDetails } from './actions';
import { getReturnDetails } from './reducer';
import { orderDetailsData } from '../reducer';
import { setSearchTerm } from '../../global/actions';
import { searchTerm } from '../../global/reducer';
import { openModal, closeModal, disableModal, enableModal } from '../../components/modal/actions';
import { billableDepartments, getUserAccount, selectDepartments } from '../../user/selectors';

import { TranslatedCopy } from '../../intl/TranslatedCopy';
import { H1 } from '~COMPONENTS/containers/Headers';
import Sidebar from '~COMPONENTS/sidebar/Sidebar';
import PageHeader from '~COMPONENTS/containers/PageHeader';
import ReturnDetailsHeader from './ReturnDetailsHeader';
import ReturnDetailsSidebar from './ReturnDetailsSidebar';
import ReturnDetailsSearch from './ReturnDetailsSearch';
import ReturnDetailsProducts from './ReturnDetailsProducts';

import { DownloadModal, DownloadModalCancelOverlay } from '../../downloads';

import { mapDepartmentName } from '../status/util';
import { toTitleCase } from '../../util/toTitleCase';
import { RETURN_REASONS } from '../orderReturns/constants';
import { STATUS_IDLE, REPORT_TYPE_RETURN } from '../../downloads/constants';
import { getIsGreaterChinaSalesOrg } from '../../gamedayAccount/selectors';
import { ORDERTYPE_STRING_MAP } from '../constants';

export class ReturnDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cachedSearchTerm: ''
    };
  }

  async componentDidMount() {
    document.body.classList.add('details');
    const { requestSubmittedReturnDetails, setSearchTerm } = this.props;
    await requestSubmittedReturnDetails(window.location.pathname.split('/').pop()).then(async () => {
      const { searchTerm } = this.props;
      await this.setState({ cachedSearchTerm: searchTerm || '' });
      await setSearchTerm('');
    });
  }

  componentWillUnmount() {
    const { cachedSearchTerm } = this.state;
    const { setSearchTerm } = this.props;
    if (cachedSearchTerm && cachedSearchTerm !== '') setSearchTerm(cachedSearchTerm);
    document.body.classList.remove('details');
  }

  onSearchChange = async value => {
    const { setSearchTerm } = this.props;
    await setSearchTerm(value);
  };

  onDownloadConfirm = () => {
    const { closeModal, disableModal, generateReport, options } = this.props;

    generateReport({
      type: REPORT_TYPE_RETURN,
      data: {
        returnId: window.location.pathname.split('/').pop(),
        includeImages: options?.includes('images') || false,
        includeUPC: options?.includes('upc') || false,
        includeSizes: options?.includes('sizes') || false,
        title: 'downloads.type.report.rs'
      }
    });
    closeModal();
    disableModal();
  };

  cancelDownload = () => {
    const { setStatus, enableModal } = this.props;
    setStatus(STATUS_IDLE);
    enableModal();
  };

  // Doesn't work with new returns
  // TODO: Implement once BE is done
  onDownloadClicked = e => {
    e.preventDefault();
    // --
    const { openModal, closeModal } = this.props;
    openModal({
      type: 'alert',
      title: new TranslatedCopy({
        id: 'global.download.value',
        values: { item: new TranslatedCopy({ id: 'returnDetails.return' }).toString() }
      }).toString(),
      content: <DownloadModal type={REPORT_TYPE_RETURN} />,
      confirmText: new TranslatedCopy({ id: 'global.download' }).toString(),
      confirmAction: this.onDownloadConfirm,
      cancelText: new TranslatedCopy({ id: 'global.button.cancel' }).toString(),
      cancelAction: closeModal,
      disabledContent: <DownloadModalCancelOverlay cancelDownload={this.cancelDownload} />
    });
  };

  onPrintClicked = e => {
    e.preventDefault();
    window.print();
  };

  render() {
    const {
      billableDepartments,
      searchTerm,
      returnDetails,
      orderDetails,
      userAllDepartments,
      account,
      isGreaterChinaSalesOrg
    } = this.props;
    const {
      accountNumber,
      departmentNumber,
      status,
      creditType,
      reasonCode,
      comments,
      referenceId,
      createdBy,
      createTimestamp,
      expirationDate,
      productToReturn,
      returnAuthorizationId,
      currencyCode,
      warehouseAddress,
      taxTotal
    } = returnDetails;
    const {
      customerPO,
      sapOrderNumber,
      orderType,
      submittedByEmail,
      submittedBy,
      paymentMethod,
      productDetails
    } = orderDetails;

    const returnReasons = returnDetails?.reasonCode && RETURN_REASONS.filter(r => r.value === reasonCode.toString());
    const returnReason = returnReasons?.length > 0 ? returnReasons[0].label : '';

    const accountNumbers =
      billableDepartments.length > 0 ? [account.number, billableDepartments[0].customerNumber] : [account.number];
    let { departmentName } = mapDepartmentName(
      [{ departmentNumber: departmentNumber }],
      userAllDepartments,
      accountNumbers
    )[0];
    departmentName = departmentName !== undefined ? toTitleCase(departmentName) : departmentName;

    const hasSubRSOs = productToReturn?.some(product => product.receivedQty > 0) || false;

    // const calculatedTotalPrice =
    //   productToReturn && productDetails
    //     ? productToReturn.reduce(
    //         (sum, product) =>
    //           sum +
    //             productDetails[product.productCode]?.netAmount *
    //               (hasSubRSOs ? product.receivedQty : product.quantity) || 0,
    //         0
    //       )
    //     : 0;
    const calculatedTotalPrice = returnDetails ? returnDetails.creditedAmount : 0;

    const accountName = account
      ? account.name
      : userAllDepartments.filter(({ customerNumber }) => customerNumber === accountNumber)[0].customerName;

    const totalQty = productToReturn?.reduce((sum, product) => sum + product.quantity || 0, 0) || 0;

    return (
      <div className='returnDetails'>
        <div className='returnDetails__main u-full-width'>
          <PageHeader
            page='returnDetails'
            className='returnDetails__header u-full-width'
            title={
              <ReturnDetailsHeader
                returnId={returnAuthorizationId}
                status={status}
                totalProducts={productToReturn ? productToReturn.length : 0}
                onPrintClicked={this.onPrintClicked}
                onDownloadClicked={this.onDownloadClicked}
              />
            }
          />
          <div className='returnDetails__body prl7-sm prl10-lg prl12-xl d-sm-h d-lg-b'>
            <ReturnDetailsSearch searchTerm={searchTerm} onChange={this.onSearchChange} />
            <ReturnDetailsProducts
              products={productToReturn}
              productDetails={productDetails || {}}
              currencyCode={currencyCode}
              searchTerm={searchTerm}
              isGreaterChinaSalesOrg={isGreaterChinaSalesOrg}
            />
          </div>
        </div>
        <div className='returnDetails__sidebar mb0-sm bg-white'>
          <StickyBox offsetTop={0} offsetBottom={0}>
            <Sidebar
              title={
                <H1 className='ta-sm-l pl1-sm'>
                  <TranslatedCopy id='orderreturns.returnSummary' />
                </H1>
              }
              extraClassName='mt0-sm'
              isStatic
              isOpen
            >
              <ReturnDetailsSidebar
                account={accountName}
                department={departmentName}
                orderType={ORDERTYPE_STRING_MAP[orderType]}
                customerPo={customerPO}
                orderSubmittedBy={submittedByEmail || submittedBy || null}
                orderReferenceNumber={sapOrderNumber}
                creditType={creditType}
                returnReason={returnReason}
                returnComments={comments}
                referenceId={referenceId}
                returnSubmittedBy={createdBy}
                returnSubmittedDate={createTimestamp}
                returnExpirationDate={expirationDate}
                totalQty={totalQty || 0}
                totalReturnAmount={calculatedTotalPrice}
                taxTotal={taxTotal}
                currencyCode={currencyCode || 'USD'}
                paymentMethod={paymentMethod}
                isGreaterChinaSalesOrg={isGreaterChinaSalesOrg}
                warehouseAddress={warehouseAddress}
              />
            </Sidebar>
          </StickyBox>
        </div>
        <div className='u-full-width prl5-sm mrl0-lg d-sm-b d-lg-h'>
          <ReturnDetailsSearch searchTerm={searchTerm} onChange={this.onSearchChange} />
          <ReturnDetailsProducts
            products={productToReturn}
            productDetails={productDetails || {}}
            currencyCode={currencyCode}
            searchTerm={searchTerm}
            isGreaterChinaSalesOrg={isGreaterChinaSalesOrg}
            hasSubRSOs={hasSubRSOs}
          />
        </div>
      </div>
    );
  }
}

ReturnDetails.propTypes = {
  account: userAccountTypes,
  billableDepartments: departmentsTypes,
  closeModal: PropTypes.func.isRequired,
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  disableModal: PropTypes.func.isRequired,
  enableModal: PropTypes.func.isRequired,
  requestSubmittedReturnDetails: PropTypes.func.isRequired,
  returnDetails: PropTypes.object,
  orderDetails: PropTypes.object,
  searchTerm: PropTypes.string.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  userAllDepartments: PropTypes.arrayOf(userDepartmentTypes),
  setStatus: PropTypes.func.isRequired,
  options: PropTypes.array,
  generateReport: PropTypes.func.isRequired
};

ReturnDetails.defaultProps = {
  account: null,
  billableDepartments: null,
  returnDetails: null,
  orderDetails: {},
  userAllDepartments: null,
  options: null
};

const mapStateToProps = state => {
  const account = getUserAccount(state);
  const returnDetails = getReturnDetails(state);
  const orderDetails = orderDetailsData(state) || {};
  const currencyCode = returnDetails.currencyCode || account.currencyCode;

  return {
    billableDepartments: billableDepartments(state),
    searchTerm: searchTerm(state),
    returnDetails,
    orderDetails,
    currencyCode,
    account,
    userAllDepartments: selectDepartments(state),
    isGreaterChinaSalesOrg: getIsGreaterChinaSalesOrg(state),
    options: options(state)
  };
};

const connector = connect(mapStateToProps, {
  setSearchTerm,
  openModal,
  closeModal,
  disableModal,
  enableModal,
  requestSubmittedReturnDetails,
  setStatus,
  generateReport
});

export default connector(ReturnDetails);
